export default __webpack_public_path__ + "static/media/zonsopgangKlein.bcea7360.jpg";